/**
 * Shared helpers for tri-state filter selects used across filter panels.
 * A tri-state select has three options: All (empty), a positive value, and a negative value.
 */

export const triStateOptions = (yesLabel, noLabel) => [
  { value: "", label: "All" },
  { value: "1", label: yesLabel },
  { value: "0", label: noLabel },
]

export const getTriStateValue = (options, paramValue) =>
  options.find(opt => opt.value === (paramValue ?? "")) ?? options[0]

export const triStateOptionsWithCounts = (yesLabel, noLabel, yesCount, noCount) => [
  { value: "", label: "All" },
  {
    value: "1",
    label: yesCount != null ? `${yesLabel} (${yesCount})` : yesLabel,
  },
  {
    value: "0",
    label: noCount != null ? `${noLabel} (${noCount})` : noLabel,
  },
]
